import Modal from "react-modal";
import * as theme from "../theme";
import CancelIcon from "@material-ui/icons/Cancel";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useLayoutEffect, useState } from "react";
import {
  getBrokerTeamInfo,
  getBrokerTeamMembers,
  getIRSCodeOnly,
  getSTCoptionsMeetYourTeam,
  getSTCoptionValue,
  updateSTCModalStatus,
  updateStcOptionsAddResponsesSelected,
  updateSTCoptionSelectedValue,
  updateStcOptionsTeamSelected,
  getProspectDetails,
  getSTCoptions,
  getSTCoptionsInsurerSelected,
} from "../store/quotes";
import { updateProspectStatus, getFormState } from "../store/qf"
import { getRowDetailsFromProspectId } from "../store/myquotes";
import {
  RecommendationType,
  emailBodyClientPresentation,
} from "../helper/constants";
import { makeStyles } from "@material-ui/core/styles";
import CropSquareIcon from "@material-ui/icons/CropSquare";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { PossibleApiStatusValues } from "../store/helperfuncs";
import { getBrokerInformation } from "../store/broker";
import _ from "lodash";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import Select from "react-dropdown-select";
import { toast } from "react-toastify";
import CustomOptionInsurerList from "./CustomOptionInsurerList";
import CoverageRcmd from "./CoverageRcmd";
import AboutUsSingleSelect from "./AboutUsSingleSelect";
import { getClientPDFfromURL, getClientPDFstatus } from "../store/components";
import PaymentOption from "./paymentoption/PaymentOption";
import { DEFAULT_SELECTED_OPTION } from "../store/businesslogic/hardwiredlogic";
import {
  getAllPaymentOptionProvider,
  getPaymentOptionProviders,
} from "../store/paymentprovider";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import { Form, Button } from "react-bootstrap"; // Assuming you're using React-Bootstrap
import PdfSettingsModal from "../components/PdfSettingsModal";

const SendToClientModal = ({ isopen, popupHeight, popupWidth, insurerId }) => {
  return (
    <Modal
      isOpen={isopen}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: `${popupHeight}vh`,
          width: `${popupWidth}vw`,
          position: "absolute",
          top: `${Math.floor((100 - popupHeight) / 2)}vh`,
          left: `${Math.floor((100 - popupWidth) / 2)}vw`,
          right: 0,
          bottom: 0,
          background: "white",
          WebkitOverflowScrolling: "touch",
          border: `8px solid white`,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <SendToClientModalContent
        insurerId={insurerId}
      ></SendToClientModalContent>
    </Modal>
  );
};

const SendToClientModalContent = ({ insurerId }) => {
  const useStyles = makeStyles(
    theme.customMaterialUIClassForScrollBarDarkBackgrond
  );
  const dispatch = useDispatch();
  const selectedinsurer = useSelector(getSTCoptionsInsurerSelected);
  const [isPaymentProvider, setIsPaymentProvider] = useState(false);
  const [isFrench, setIsFrench] = useState(false); // Local state to manage language toggle
  const broker = useSelector(getBrokerInformation);
  const languagecode = broker.information.languagepreference || "en";
  const translations = {
    en: {
      // Existing translations
      sendToInsurers: "Send To Insurers",
      insurersMatch:
        "These insurers are recommended as a potential match for your client.",
      digitalMarketingHub: "Digital Marketing Hub",
      digitalHubDescription:
        "In the digital marketing hub you’ll automatically see responses from participating insurers, and can also track responses from other markets.",
      // New translations
      customizePresentation: "Customize your Client Presentation",
      selectOptionsDescription:
        "Please select from the options below to customize the presentation you send to your client. Some options may not be available depending on the nature of the client and quotes available and selected.",
      includeAboutUs: 'Include "About Us" page for your brokerage',
      includeMeetTeam: 'Include "Meet your team" page',
      includeCompletedApplication:
        "Include a completed application to review and sign",
      includeInsurersList:
        "Include list of all insurers approached and their response",
      includeQuotesComparison:
        "Include details and comparison of selected insurer quotes",
      includePaymentOptions: "Include payment options",
      includeCoverageRecommendations:
        "Include other coverage recommendations to client",
      downloadPDF: "Download PDF",
      editPDFSettings: "Edit PDF Settings",
      loading: "Loading...",
      failedTryAgain: "Failed! Try again?",
      
      downloadAgain: "Download again",
      downloadClientPresentation: "Download Client Presentation",
      downloadEmailWithPDF: "Download an email including a PDF",
      languageEN: "EN",
      languageFR: "FR",
      emailSubject: "Your Insurance",
    },
    fr: {
      // Existing translations
      sendToInsurers: "Envoyer aux Assureurs",
      insurersMatch:
        "Ces assureurs sont recommandés comme correspondance potentielle pour votre client.",
      digitalMarketingHub: "Plate-forme numérique",
      digitalHubDescription:
        "Dans le centre de marketing numérique, vous verrez automatiquement les réponses des assureurs participants et pourrez également suivre les réponses d'autres marchés.",
      // New translations
      customizePresentation: "Personnalisez votre présentation client",
      selectOptionsDescription:
        "Veuillez sélectionner parmi les options ci-dessous pour personnaliser la présentation que vous envoyez à votre client. Certaines options peuvent ne pas être disponibles en fonction de la nature du client et des devis disponibles et sélectionnés.",
      includeAboutUs: 'Inclure la page "À propos de nous" pour votre cabinet',
      includeMeetTeam: 'Inclure la page "Rencontrez votre équipe"',
      includeCompletedApplication:
        "Inclure une demande complétée à examiner et à signer",
      includeInsurersList:
        "Inclure la liste de tous les assureurs contactés et leur réponse",
      includeQuotesComparison:
        "Inclure les détails et la comparaison des devis des assureurs sélectionnés",
      includePaymentOptions: "Inclure les options de paiement",
      includeCoverageRecommendations:
        "Inclure d'autres recommandations de couverture pour le client",
      downloadPDF: "Télécharger le PDF",
      editPDFSettings: "Modifier les paramètres du PDF",
      loading: "Chargement...",
      failedTryAgain: "Échec ! Réessayer ?",
      downloadAgain: "Télécharger à nouveau",
      downloadClientPresentation: "Télécharger la présentation client",
      downloadEmailWithPDF: "Télécharger un e-mail incluant un PDF",
      languageEN: "EN",
      languageFR: "FR",
      emailSubject: "Votre assurance",
    },
  };
  const language = isFrench ? "fr" : "en";
  const t = translations[languagecode]; // Helper to access translations easily
  console.log("show me the lang", language);
  const handleLanguageToggle = (e) => {
    console.log("handle the lang switch up");
    localStorage.setItem("pdfLanguagePrefIsFrench", !isFrench);
    // e.preventDefault();
    // e.stopPropagation(); // This stops the event from bubbling up to the dropdown item
    setIsFrench(!isFrench);
  };
  const handleCloseButton = () => {
    dispatch(updateSTCModalStatus({ status: false }));
  };

  useEffect(() => {
    const pdfLanguagePrefIsFrench =
      localStorage.getItem("pdfLanguagePrefIsFrench") === "true";
    setIsFrench(pdfLanguagePrefIsFrench);
    console.log("show me this lang in use", pdfLanguagePrefIsFrench);
  });

  //TODO this condition is used when PDF generate then modal closed.
  // useEffect(()=>{
  //   if(clientPdfStatus === PossibleApiStatusValues.success){
  //     handleCloseButton();
  //   }
  // },[clientPdfStatus])
  useEffect(() => {
    dispatch(updateStcOptionsAddResponsesSelected());
    const onKeyPressed = (e) => {
      if (e.keyCode === 27) {
        dispatch(updateSTCModalStatus({ status: false }));
      }
    };
    document.addEventListener("keydown", onKeyPressed);

    return () => {
      document.removeEventListener("keydown", onKeyPressed);
    };
  }, [dispatch]);

  const heights = {
    desc: "12%",
    proceedbutton: "8%",
    somegapbetween: "2%",
    remainingHeight: "",
  };

  heights.remainingHeight = `calc(100% - ${heights.desc} - ${heights.proceedbutton} - ${heights.somegapbetween})`;
  const classes = useStyles();
  const irsCodeOnly = useSelector(getIRSCodeOnly);
  const stcoptions = useSelector(getSTCoptions);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const clientPdfStatus = useSelector(getClientPDFstatus);
  let prospectid = window.location.search.split("id=")[1];
  const prospectDetails = useSelector(
    getRowDetailsFromProspectId({ prospectid })
  );
  const formstate = useSelector(getFormState);

  const handleProceedClick = (sendEml = false) => {
    const showTOC = localStorage.getItem("showTOC") === "true";
    const showAnsweredOnly =
      localStorage.getItem("showAnsweredOnly") === "true";
    const pdfLanguagePrefIsFrench =
      localStorage.getItem("pdfLanguagePrefIsFrench") === "true";
    var verified = { msg: "", status: true };
    const languagepreference = pdfLanguagePrefIsFrench ? "fr" : "en"
    var body = {
      id: irsCodeOnly,
      include_toc: showTOC,
      show_empty_answers: showAnsweredOnly,
      pdf_language_selected: pdfLanguagePrefIsFrench ? "fr" : "en",
      client_name: (formstate?.a?.nodestate?.[10501]?.answer || formstate?.a?.nodestate?.[10507]?.answer || formstate?.a?.nodestate?.[10101]?.answer || "").trim(),
    };
    if (
      stcoptions.meetyourteam.selected &&
      (!stcoptions.meetyourteam.teamselected ||
        stcoptions.meetyourteam.teamselected.length == 0)
    ) {
      verified.status = false;
      verified.msg =
        'Please select team members OR uncheck the "Meet your team" box';
    }
    if (sendEml) {
      body = {
        id: irsCodeOnly,
        downloadingEml: true,
        mailto: prospectDetails.CLIENT_EMAIL,
        bcc: "",
        body: emailBodyClientPresentation[languagepreference].replaceAll(
          "<<brokername>>",
          prospectDetails.brokername
        ),
        subject: translations[languagepreference].emailSubject,
        include_toc: showTOC,
        show_empty_answers: showAnsweredOnly,
        pdf_language_selected: languagepreference,
        client_name: (formstate?.a?.nodestate?.[10501]?.answer || formstate?.a?.nodestate?.[10507]?.answer || formstate?.a?.nodestate?.[10101]?.answer || "").trim(),
      };
    }
    if (verified.status) {
      if(stcoptions?.comparison?.selected){
        dispatch(updateProspectStatus({prospectid, statuscode:'quote_to_client'}))
      }
      dispatch(getClientPDFfromURL(body));
    } else {
      toast(verified.msg);
    }
  };

  const hDist = {
    headingHeight: "10%",
    remainingHeight: "",
  };

  hDist.remainingHeight = `calc(100% - ${hDist.headingHeight})`;
  useLayoutEffect(() => {
    if (selectedinsurer?.id === "NOSELECTION") {
      dispatch(
        updateSTCoptionSelectedValue({
          key: "rawQuoteInformation",
          value: false,
        })
      );
    } else {
      dispatch(
        updateSTCoptionSelectedValue({
          key: "rawQuoteInformation",
          value: false,
        })
      );
    }
  }, [selectedinsurer?.id === "NOSELECTION"]);

  const paymentProviders = useSelector(getPaymentOptionProviders);

  useEffect(async () => {
    await dispatch(getAllPaymentOptionProvider());
  }, [dispatch]);

  useEffect(() => {
    if (paymentProviders.length === 0) {
      dispatch(
        updateSTCoptionSelectedValue({
          key: "rawQuoteInformation",
          value: false,
        })
      );
      setIsPaymentProvider(true);
    }
  }, [paymentProviders.length === 0]);

  useEffect(() => {
    if (paymentProviders.length === 0 && selectedinsurer?.id != "NOSELECTION") {
      dispatch(
        updateSTCoptionSelectedValue({
          key: "rawQuoteInformation",
          value: false,
        })
      );
    }
  }, [paymentProviders.length === 0 && selectedinsurer?.id != "NOSELECTION"]);

  useEffect(() => {
    if (paymentProviders.length > 0) {
      setIsPaymentProvider(false);
    }
  }, [paymentProviders]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        backgroundColor: theme.COLORS.primary_navyblue,
      }}
    >
      <div
        style={{
          height: hDist.headingHeight,
          width: "100%",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: theme.COLORS.secondary_skyblue,
            fontSize: "1.9vmin",
            letterSpacing: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
            fontFamily: "GibsonRegular",
          }}
        >
          {t.customizePresentation}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: hDist.remainingHeight,
          backgroundColor: theme.COLORS.primary_navyblue,
          padding: "2vmin",
          paddingTop: 0,
        }}
      >
        <div style={{ position: "absolute", top: 0, right: 0 }}>
          <CancelIcon
            fontSize="large"
            style={{ cursor: "pointer", color: "white" }}
            onClick={handleCloseButton}
          />
        </div>
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            color: "white",
            fontFamily: "GibsonRegular",
          }}
        >
          <div
            style={{
              width: "100%",
              height: heights.desc,
              fontSize: "1.7vmin",
              letterSpacing: 1,
              fontFamily: "GibsonLight",
              padding: "2vmin",
              paddingLeft: 0,
            }}
          >
            {t.selectOptionsDescription}
          </div>
          <div
            style={{
              width: "100%",
              height: heights.remainingHeight,
              fontSize: "1.9vmin",
              letterSpacing: 1,
              overflow: "auto",
              paddingRight: "1vw",
            }}
            className={classes.responses}
          >
            <CustomOptions
              optiontype={"aboutus"}
              maintext={t.includeAboutUs}
              extracomponent={<AboutUsSingleSelect />}
            />
            <CustomOptions
              optiontype={"meetyourteam"}
              maintext={t.includeMeetTeam}
              extracomponent={<TeamSelection />}
            />
            <CustomOptions
              optiontype={"reviewsign"}
              maintext={t.includeCompletedApplication}
            />
            <CustomOptions
              optiontype={"listinsurers"}
              maintext={t.includeInsurersList}
            />
            <CustomOptions
              optiontype={"comparison"}
              maintext={t.includeQuotesComparison}
              extracomponent={
                <CustomOptionInsurerList optiontype={"comparison"} />
              }
            />

            {isPaymentProvider ||
            (selectedinsurer && selectedinsurer?.id === "NOSELECTION") ||
            selectedinsurer === null ? null : (
              <CustomOptions
                optiontype={"rawQuoteInformation"}
                maintext={t.includePaymentOptions}
                extracomponent={
                  <PaymentOption
                    prospectid={prospectid}
                    insurerId={insurerId}
                  />
                }
              />
            )}
            <CustomOptions
              optiontype={"covers"}
              maintext={t.includeCoverageRecommendations}
              extracomponent={<CoverageRcmd />}
            />
          </div>
          <div
            style={{
              width: "100%",
              height: heights.somegapbetween,
            }}
          />
          <div
            style={{
              width: "100%",
              display: "inline-flex",
              height: heights.proceedbutton,
            }}
          >
            <DropdownButton
              style={{
                paddingTop: "10px",
                width: "98%",
              }}
              className="bindModal"
              variant="warning"
              title={t.downloadPDF}
            >
              <Dropdown.Item
                style={{
                  width: "100%",
                }}
                eventKey="2"
                onClick={() => {
                  setIsModalOpen(true);
                }}
              >
                {t.editPDFSettings}
              </Dropdown.Item>
              <Dropdown.Item
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
                eventKey="1"
                onClick={() => handleProceedClick(false)}
              >
                <span>
                  {clientPdfStatus === PossibleApiStatusValues.loading
                    ? t.loading
                    : clientPdfStatus === PossibleApiStatusValues.failed
                    ? t.failedTryAgain
                    : clientPdfStatus === PossibleApiStatusValues.success
                    ? t.downloadAgain
                    : t.downloadClientPresentation}
                </span>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <span style={{ marginRight: 5 }}>{t.languageEN}</span>
                  <Form.Check
                    type="switch"
                    id="language-toggle"
                    checked={language === "fr"}
                    onChange={handleLanguageToggle}
                    style={{ marginBottom: 0 }}
                  />
                  <span style={{ marginLeft: 5 }}>{t.languageFR}</span>
                </div>
                {/* <span>
                  {clientPdfStatus === PossibleApiStatusValues.loading
                    ? t.loading
                    : clientPdfStatus === PossibleApiStatusValues.failed
                    ? t.failedTryAgain
                    : clientPdfStatus === PossibleApiStatusValues.success
                    ? t.downloadAgain
                    : t.downloadClientPresentation}
                </span>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <span style={{ marginRight: 5 }}>{t.languageEN}</span>
                  <Form.Check
                    type="switch"
                    id="language-toggle"
                    checked={language === "fr"}
                    onChange={handleLanguageToggle}
                    style={{ marginBottom: 0 }}
                  />
                  <span style={{ marginLeft: 5 }}>{t.languageFR}</span>
                </div> */}
              </Dropdown.Item>

              <Dropdown.Item
                style={{
                  width: "100%",
                }}
                eventKey="2"
                onClick={() => handleProceedClick(true)}
              >
                {t.downloadEmailWithPDF}
              </Dropdown.Item>
            </DropdownButton>
            <PdfSettingsModal
              open={isModalOpen}
              onClose={() => setIsModalOpen(false)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const TeamSelection = () => {
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference;

  // Translation object for different languages
  const translations = {
    en: {
      selectTeamMembers:
        "Select up to 3 team members who will be featured in the client presentation",
    },
    fr: {
      selectTeamMembers:
        "Sélectionnez jusqu'à 3 membres de l'équipe qui seront présentés dans la présentation au client",
    },
  };

  // Optional: Define a default language in case languagecode is undefined or not supported
  const defaultLanguage = "en";
  const currentLanguage = translations[languagecode]
    ? languagecode
    : defaultLanguage;

  return (
    <div
      style={{
        width: "100%",
        minHeight: "7vh",
        paddingLeft: "9vmin",
        fontSize: "1.5vmin",
        paddingTop: "1vh",
      }}
    >
      <span style={{ fontFamily: "GibsonLightIt" }}>
        {translations[currentLanguage].selectTeamMembers}
      </span>
      <TeamSelectionDropDown />
    </div>
  );
};

const EachTeamMember = ({ cursor, item, selected, index, methods, state }) => {
  const NUMBER_CAP_TEAMS = 3;
  return (
    <div
      key={index}
      style={{
        backgroundColor: theme.COLORS.primary_navyblue,
        color: "white",
        height: "5vh",
        display: "flex",
        alignItems: "center",
        paddingLeft: "2vmin",
      }}
      onClick={() => {
        if (item) {
          if (state.values.length > NUMBER_CAP_TEAMS - 1) {
            toast(
              "You can select up to " +
                NUMBER_CAP_TEAMS +
                " of your team members"
            );
          } else methods.addItem(item);
        }
      }}
    >{`${item.firstname} ${item.lastname}`}</div>
  );
};
const TeamSelectionDropDown = () => {
  const dispatch = useDispatch();
  const brokerteam = useSelector(getBrokerTeamMembers);
  const { information } = useSelector(getBrokerInformation);
  useEffect(() => {
    if (brokerteam === PossibleApiStatusValues.notstarted) {
      // get broker team from server
      let brokeragecode = null;
      // data gathering
      try {
        brokeragecode = information.brokerages[0].code;
      } catch (e) {
        console.log("Cannot get first brokerage code of the user");
      }

      dispatch(getBrokerTeamInfo({ brokeragecode }));
    }
  }, []);

  const dropdownRenderer = ({ props, state, methods }) => {
    const regexp = new RegExp(state.search, "i");
    let rows = props.options
      .filter((item) => {
        return regexp.test(`${item.firstname} ${item.lastname}`);
      })
      .map((item, index) => (
        <EachTeamMember
          key={index}
          index={index}
          cursor={state.cursor}
          item={item}
          methods={methods}
          selected={methods.isSelected(item)}
          state={state}
        ></EachTeamMember>
      ));

    return (
      <div>
        <div
          style={{
            minHeight: "15vh",
            color: "white",
            backgroundColor: theme.COLORS.dark_navy_blue,
          }}
        >
          {rows}
        </div>
      </div>
    );
  };

  const selectStyles = {
    placeholder: (defaultStyles, state) => {
      return {
        ...defaultStyles,
        color: "green",
      };
    },
  };

  const onChangeHandle = (values) => {
    // update this values in the database
    dispatch(updateStcOptionsTeamSelected({ selectedteamsarray: values }));
  };

  const teamSelectedStoreValue = useSelector(getSTCoptionsMeetYourTeam);
  return (
    <div style={{ paddingTop: "1vmin" }}>
      {brokerteam === PossibleApiStatusValues.notstarted ? (
        <div></div>
      ) : brokerteam === PossibleApiStatusValues.loading ? (
        <div></div>
      ) : (
        <Select
          multi
          placeholder={``}
          color={theme.COLORS.primary_navyblue}
          searchable={true}
          onChange={(values) => onChangeHandle(values)}
          values={teamSelectedStoreValue}
          options={brokerteam.brokers}
          style={{
            width: "50%",
            minHeight: "6vmin",
            fontSize: "1.9vmin",
            border: "3px solid white",
            borderRadius: 10,
            fontFamily: "GibsonRegular",
            color: "white",
          }}
          dropdownRenderer={dropdownRenderer}
          labelField={`firstname`}
          valueField={"_id"}
          onDropdownClose={() => {
            // dispatch(changeShowRecentQuotesTable(true));
          }}
          onDropdownOpen={() => {
            //dispatch(changeShowRecentQuotesTable(false));
          }}
        />
      )}
    </div>
  );
};

const CustomOptions = ({ optiontype, maintext, extracomponent }) => {
  const selectedvalue = useSelector(getSTCoptionValue(optiontype));
  const commonStyle = { fontSize: "3.5vmin", cursor: "pointer" };
  const dispatch = useDispatch();
  const handleCheckedboxClick = () => {
    dispatch(updateSTCoptionSelectedValue({ key: optiontype, value: false }));
  };
  const handleEmptyBoxClick = () => {
    dispatch(updateSTCoptionSelectedValue({ key: optiontype, value: true }));
  };
  const commonStyleFordivs = {
    paddingLeft: "2vmin",
    paddingRight: "2vmin",
  };
  return (
    <div
      style={{
        width: "100%",
        minHeight: "7vh",
        display: "flex",
        alignItems: "center",
        paddingBottom: "2vh",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: "100%",
          minHeight: "4vh",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          ...commonStyleFordivs,
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{ minHeight: "2vh", display: "flex", alignItems: "center" }}
          >
            {selectedvalue ? (
              <CheckBoxIcon
                style={{ ...commonStyle }}
                onClick={handleCheckedboxClick}
              ></CheckBoxIcon>
            ) : (
              <CropSquareIcon
                style={{ ...commonStyle }}
                onClick={handleEmptyBoxClick}
              ></CropSquareIcon>
            )}
          </div>
          <div style={{ width: "5vmin" }}></div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "2vh",
              fontSize: "1.8vmin",
              fontFamily: "GibsonRegular",
            }}
          >
            {maintext}
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          ...commonStyleFordivs,
        }}
      >
        {selectedvalue ? (extracomponent ? extracomponent : null) : null}
      </div>
    </div>
  );
};

export default SendToClientModal;
